import { includes, replace } from 'lodash';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const imgOriginUrlPrefix = publicRuntimeConfig.imgOriginUrlPrefix;
const imgSharpieUrlPrefix = publicRuntimeConfig.imgSharpieUrlPrefix;

export const handleImageUrl = (
  imgUrl: string,
  width: number,
  height: number,
  isNextGenSupported = false,
  option = 'crop',
) => {
  if (includes(imgUrl, imgOriginUrlPrefix)) {
    return replace(
      imgUrl,
      imgOriginUrlPrefix,
      `${imgSharpieUrlPrefix}${width}x${height}${
        isNextGenSupported ? '-' + option + ',format=webp/' : '-' + option + '/'
      }`,
    );
  }
  return imgUrl;
};

export const handleShareImageUrl = (imageUrl: string) => {
  if (imageUrl.substring(0, 2) === '//') {
    return `https:${imageUrl}`;
  }
  return imageUrl;
};
